import moment from 'moment'
import { Maybe } from 'types/graphqlTypes'
import { TSavedLaneSchema } from '../schema'
import { DaysOfWeekSchemaObject } from '../schema/DaysOfWeekSchema'

/**
 * Returns a SavedLaneSchema daysOfWeek object from an array of IsoWeekdays
 *
 * @example getSavedLaneSchemaDaysOfWeek([1, 2])
 * // { monday : true, tuesday : true, wednesday : false, thursday : false, friday : false, saturday : false, sunday : false }
 */
export const getSavedLaneSchemaDaysOfWeek = (
  pickupIsoDaysOfWeek: Maybe<number[]>
): TSavedLaneSchema['daysOfWeek'] => {
  if (!pickupIsoDaysOfWeek || pickupIsoDaysOfWeek.length === 7) {
    return null
  }

  const puTupple = Object.keys(DaysOfWeekSchemaObject).map(day => [
    day,
    pickupIsoDaysOfWeek.includes(moment().isoWeekday(day).isoWeekday()),
  ])

  return Object.fromEntries(puTupple)
}
